module.exports = __webpack_public_path__ + "media/bg/notification_bg-b65b079b.jpg";